// extracted by mini-css-extract-plugin
export default {"main_container":"style_main_container__175aF"};